import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <NavLink to="/" className="nav-logo">
          <img src="/logo.png" alt="Apexio Labs Logo" />
          <span>Apexio Labs</span>
        </NavLink>

        <div className={isOpen ? "nav-menu active" : "nav-menu"}>
          <NavLink to="/" className="nav-item" onClick={() => setIsOpen(false)}>Home</NavLink>
          <NavLink to="/about" className="nav-item" onClick={() => setIsOpen(false)}>About Us</NavLink>
          <NavLink to="/services" className="nav-item" onClick={() => setIsOpen(false)}>Services</NavLink>
          <NavLink to="/careers" className="nav-item" onClick={() => setIsOpen(false)}>Careers</NavLink>
          <NavLink to="/contact" className="nav-item nav-contact-btn" onClick={() => setIsOpen(false)}>
            Contact Us
          </NavLink>
        </div>

        <div className="nav-toggler" onClick={() => setIsOpen(!isOpen)}>
          <div className={isOpen ? "line1 active" : "line1"}></div>
          <div className={isOpen ? "line2 active" : "line2"}></div>
          <div className={isOpen ? "line3 active" : "line3"}></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;